import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { AppointmentButtonServant } from '../../servants/appointment_button_servant';
import MyAppointmentsStateService from '../../services/my_appointment_state_service';
import { IAlternateAppointmentConfirm } from '../../types/appointment_interfaces';
import { TAppointmentLocationsOrganizersUsersource } from '../../usersources/appointment_location_staff_usersource';
import { TAppointmentReasonUsersource } from '../../usersources/appointment_reason_usersource';

export class AlternateAppointmentTimesConfirmController {
  public model: IAlternateAppointmentConfirm;
  isRequestWorkflowBlocked: boolean = false;

  constructor(
    public ngAppointmentLocationsOrganizersUsersource: TAppointmentLocationsOrganizersUsersource,
    private ngAlternateAppointmentTimesUsersource: any,
    private accountModel: any,
    private log: any,
    private ngAppointmentReasonUsersource: TAppointmentReasonUsersource,
    private ngMyAppointmentsStateService: MyAppointmentsStateService,
    private alternateAppointmentTimesConfirmationCommand: ICommand,
    private ngAppointmentButtonServant: AppointmentButtonServant
  ) {
    this.confirmAlternateAppointmentTimes = this.confirmAlternateAppointmentTimes.bind(this);
  }

  $onInit() {
    this.isRequestWorkflowBlocked =
      !this.ngAppointmentLocationsOrganizersUsersource.read().selectedLocation.can_request;
    this.model = {
      student: this.accountModel.fullname,
      subject: `${this.ngAppointmentReasonUsersource.read().selectedType.name}, ${
        this.ngAppointmentReasonUsersource.read().selectedService.name
      }`,
      location: this.ngAlternateAppointmentTimesUsersource.read().selectedLocation.name,
      availability: this.ngAlternateAppointmentTimesUsersource.availability
    };
    this.ngAppointmentButtonServant.configButton({
      buttonText: 'Send Request',
      isDisabled: false,
      action: () => this.confirmAlternateAppointmentTimes()
    });
    this.ngMyAppointmentsStateService.stateLoaded();
  }

  confirmAlternateAppointmentTimes(): void {
    this.alternateAppointmentTimesConfirmationCommand().then(
      (response: any) => {
        this.log.user.success('Appointment request submitted.');
        this.ngMyAppointmentsStateService.goToScheduled();
      },
      () => {
        this.log.user.success('Unable to make Appointment request.');
      }
    );
  }
}

angular
  .module('capability-ng-appointments')
  .controller('AlternateAppointmentTimesConfirmController', AlternateAppointmentTimesConfirmController);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/views/alternate_appointment_times_confirm/alternate_appointment_times_confirm.ts